import axios from "axios";
import Token from "../../utilities/jwt/Token.js";
import { gerarUrl } from "../../utilities/utils/Pageable";

export default class FileService extends Token {

  /*BUSCANDO ARQUIVOS POR PROJETO*/
  findFilesByFolderId(queryParams) {
    queryParams = gerarUrl(queryParams);
    return axios({
      method: "get",
      url: this.api_url + "file?" + queryParams,
      withCredentials: true,
    }).then((res) => res.data);
  }

  /*BAIXANDO UM ARQUIVO*/
  download(file) {
    return axios({
      method: "get",
      url: this.api_url + "file/download/" + file,
      withCredentials: true,
      responseType: "blob"
    });
  }

  /*UPDANDO UM ARQUIVO PARA DENTRO DE UM DIRETORIO*/
  upload(arquivo, folderId) {
    return axios({
      method: "post",
      url: this.api_url + "file/upload?folder=" + folderId,
      withCredentials: true,
      data: { file: arquivo },
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    }).then((response) => response);
  }

  /*ATUALIZANDO UM ARQUIVO DENTRO DE UM DIRETORIO*/
  update(hashKey, arquivo) {
    return axios({
      method: "put",
      url: this.api_url + "file/" + hashKey,
      withCredentials: true,
      data: { file: arquivo },
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    }).then((response) => response);
  }

  /*REMOVENDO ARQUIVO DE DENTRO DE UM DIRETORIO*/
  remove(hashKey) {
    return axios({
      method: 'delete',
      url: this.api_url + 'file/' + hashKey,
      withCredentials: true,
    }).then((response) => response);
  }

  /*VISUZALIZANDO UM ARQUIVO PNG, JPG, JPEG OU PDF EM OUTRA ABA*/
  preview(hashKey) {
    window.open(`${this.api_url}file/preview/${hashKey}`, '_blank');
  }

  /*RETORNA A URL DE VIZUALIDAÇÃO SOMENTE PARA ARQUIVOS PNG, JPG E JPEG*/
  urlImg(file) {
    if (file.type === 'png' || file.type === 'jpg' || file.type === 'jpeg') {
      return `${this.api_url}file/preview/${file.hashKey}`;
    } else {
      this.$toast.add({
        severity: "error",
        summary: "Atenção!",
        detail: 'Somente arquivos png, jpg e jpeg podem ser exibidos',
      });
    }
  }
}
